
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/infiltration/briefing",
      function () {
        return require("private-next-pages/infiltration/briefing.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/infiltration/briefing"])
      });
    }
  